import { useDispatch, useSelector } from "react-redux"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/banner/banner"
import { useEffect } from "react"
import { retrunAssets } from "../utils/getAssets"
import { DecodeHtml } from "../utils/decodeHtml"
import { fetchQuickStaffReferenceData } from "../redux/slice/quickStaffReferencePage"


const QuickStaff = () => {

    const state = useSelector(state => state.quickStaffReference)

    const dispatch = useDispatch()

    useEffect(() => {

        dispatch(fetchQuickStaffReferenceData("staff-hub/quick-reference/"))

    }, [dispatch])


    const quick = state?.data?.properties
    const title = quick?.title
    const bg = quick?.backgroundImage != null ? retrunAssets(quick?.backgroundImage[0]?.url) : ""






    return (
        <AnimatedPage>
            <Banner text={title} bg={bg} />
            <div className="flex items-center justify-center p-8 md:px-12 ">
                <div className="w-full flex justify-center  lg:max-w-7xl">
                    <p className=" whitespace-pre-line font-normal">{DecodeHtml({html:quick?.contents?.markup})}</p>
                </div>
            </div>
        </AnimatedPage>
    )
}

export default QuickStaff